export default function formSerializer(data: any, headers: Headers) {
  const formData = new FormData();
  formData.append('api_payload', JSON.stringify(data));
  return {body: formData};
}
